import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("MovimientoCajaView");

export const MovimientoCaja = cacheResource({
    /**Obtiene todos los movimientos de caja */
    query: async (): Promise<models.MovimientoCajaViewDTO[]> => await controller('Query', {}), 

    queryFiltro: async (filtro: models.FiltroMovimientoCaja): Promise<models.MovimientoCajaViewDTO[]> => 
    await controller('queryFiltro', {}, filtro),
})


// WEBPACK FOOTER //
// ./app/resources/items/cortecaja.ts